import { type UnitSystem } from '../../../_shared/types/googleMaps/googleMaps.types';
import { calculateMapScale } from '../../../_shared/utils/map/calculateMapScale';
import { convertUnitToKilometers } from '../../../_shared/utils/unitSystem/unitSystem.helpers';

export const isProximityBigEnough = ({ radius, unit }: Readonly<{ radius: number; unit: UnitSystem }>, zoom: number) => {
  const radiusInKm = convertUnitToKilometers(radius, unit);

  return (radiusInKm / calculateMapScale(zoom)) * 1_000_000 > 1;
};
